import React from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { AlertTriangle } from 'lucide-react';
interface DisclaimerModalProps {
  isOpen: boolean;
  onAccept: () => void;
}
export function DisclaimerModal({
  isOpen,
  onAccept
}: DisclaimerModalProps) {
  return <Modal isOpen={isOpen} onClose={() => {}} // Force user to accept
  title="Important Legal Disclaimer" maxWidth="lg" footer={<div className="flex justify-end" data-id="element-98">
          <Button onClick={onAccept} size="lg" data-id="element-99">
            I Understand and Accept
          </Button>
        </div>} data-id="element-97">
      <div className="space-y-6 text-text-primary" data-id="element-100">
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 flex items-start" data-id="element-101">
          <AlertTriangle className="w-6 h-6 text-yellow-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-102" />
          <div data-id="element-103">
            <h3 className="font-bold text-yellow-800" data-id="element-104">Beta Version Warning</h3>
            <p className="text-sm text-yellow-700 mt-1" data-id="element-105">
              This is a prototype for testing purposes only. Data is stored
              locally in your browser and is NOT encrypted to HIPAA standards.
              Do not enter highly sensitive personal information.
            </p>
          </div>
        </div>

        <div className="space-y-4 text-sm leading-relaxed" data-id="element-106">
          <section data-id="element-107">
            <h4 className="font-bold text-lg mb-2" data-id="element-108">1. NOT LEGAL ADVICE</h4>
            <p data-id="element-109">
              Zapiis is a documentation tool, not a law firm. We are not
              attorneys and do not provide legal advice, representation, or
              services. Use of this tool does not create an attorney-client
              relationship.
            </p>
          </section>

          <section data-id="element-110">
            <h4 className="font-bold text-lg mb-2" data-id="element-111">
              2. NO WARRANTY OR GUARANTEE
            </h4>
            <p data-id="element-112">
              This software is provided "as is" without warranties of any kind.
              We do not guarantee that documentation created with this tool will
              be admissible in court or result in any specific legal outcome.
            </p>
          </section>

          <section data-id="element-113">
            <h4 className="font-bold text-lg mb-2" data-id="element-114">
              3. DATA SECURITY LIMITATIONS
            </h4>
            <p data-id="element-115">
              In this beta version, all data is stored in your browser's
              LocalStorage. Clearing your browser cache will delete your data.
              We do not have access to your data and cannot recover it if lost.
            </p>
          </section>

          <section data-id="element-116">
            <h4 className="font-bold text-lg mb-2" data-id="element-117">4. AI DISCLAIMER</h4>
            <p data-id="element-118">
              Features utilizing Artificial Intelligence (AI) may generate
              incorrect or misleading information. Always verify AI-generated
              summaries and attorney search results independently.
            </p>
          </section>

          <section data-id="element-119">
            <h4 className="font-bold text-lg mb-2" data-id="element-120">5. USER RESPONSIBILITIES</h4>
            <p data-id="element-121">
              You are solely responsible for the accuracy of the information you
              document and for maintaining backups of your data using the export
              feature.
            </p>
          </section>
        </div>
      </div>
    </Modal>;
}